<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-list-item-title class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-property">
            <v-text-field                                
                    label="Name"
                    v-model="value.object.metadata.name"
                    autofocus
                    :disabled="readOnly"
            ></v-text-field>
            <v-select
                    label="Subjects Kind"
                    :disabled="readOnly"
                    v-model="value.object.subjects[0].kind"
                    :items="kindList">
                <template v-slot:append-outer>
                    <v-icon small @click="desDocOpen('#referring-to-subjects')">mdi-help-circle-outline</v-icon>
                </template>
            </v-select>
            <v-text-field
                    label="Subjects Name"
                    :disabled="readOnly"
                    v-model="value.object.subjects[0].name"
            ></v-text-field>
            <v-select
                    label="Role Kind"
                    :disabled="readOnly"
                    v-model="value.object.roleRef.kind"
                    :items="roleList"
            ></v-select>
            <v-text-field
                    label="Role Name"
                    :disabled="readOnly"
                    v-model="value.object.roleRef.name"
            ></v-text-field>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        mixins: [KubernetesPanel],
        name: 'rb-property-panel',
        computed: {
            descriptionText() {
                return 'RoleBinding'
            },
        },
        data: function () {
            return {
                kindList: [ "User", "Group", "ServiceAccount" ],
                roleList: [ "Role", "ClusterRole" ],
            }
        },
        watch: {
        },
        methods: {
            desDocOpen(property) {
                var url = 'https://kubernetes.io/docs/reference/access-authn-authz/rbac/#rolebinding-and-clusterrolebinding'
                if(property) {
                    url += property
                }
                window.open(url)
            },
        }
    }
</script>

